import React from 'react'
import './Coming.css'

function Coming() {
  return (
    <div className="Coming-component">
      <div className="Coming-container"> 
        <div className="Coming-one">
            <p>Coming soon</p>
        </div>
          </div>
             <div className="Coming-three">
             <h3> ZeroOne Learning  </h3>
          </div>
      </div>
  )
}

export default Coming